const Unauthorized = () => {
  return (
    <div>
      <img src="/assets/404.png" alt="404 Not Found" />
    </div>
  )
}

export default Unauthorized
